import { render, staticRenderFns } from "./TaskDeliveryInstagramStoryProvider.vue?vue&type=template&id=46052f4c&"
import script from "./TaskDeliveryInstagramStoryProvider.vue?vue&type=script&lang=js&"
export * from "./TaskDeliveryInstagramStoryProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports